import React, { FC } from "react";
import classnames from "classnames";
import DateRangePickerOrigin, { DateRangePickerProps } from "rsuite/DateRangePicker";
import "../DatePicker/rsuite.css";
import "../DatePicker/rsuite.calendar.css";
import "./index.scss";
import moment from "moment";

interface DatPeriodPickerProps extends DateRangePickerProps {
  className?: string;
  label?: string;
  disabled?: boolean;
}

interface DatPeriodPicker {
  label: string;
  value: [Date, Date];
}

export const DatPeriodPicker: FC<DatPeriodPickerProps> = ({
  className,
  label,
  disabled,
  format = "MM/dd/yy",
  character = "-",
  ...rest
}) => {
  const ranges: DatPeriodPicker[] = [
    {
      label: "Today",
      value: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
    },
    {
      label: "Last 7 days",
      value: [moment().subtract(6, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    },
    {
      label: "Last 30 days",
      value: [moment().subtract(29, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    },
    {
      label: "Last month",
      value: [
        moment().subtract(1, "month").startOf("month").toDate(),
        moment().subtract(1, "month").endOf("month").toDate(),
      ],
    },
    {
      label: "Current month",
      value: [moment().startOf("month").toDate(), moment().endOf("month").toDate()],
    },
  ];

  return (
    <div className={classnames("date-period-picker", className, { disabled })}>
      {label && <label>{label}</label>}
      <DateRangePickerOrigin
        {...rest}
        isoWeek
        menuClassName="dataflik-date-range-menu"
        placement="auto"
        format={format}
        ranges={ranges}
        character={character}
      />
    </div>
  );
};

export default DatPeriodPicker;
